<script setup>
import dayjs from "dayjs";
import "dayjs/locale/ru";

dayjs.locale("ru");

const DEFAULT_ICON_URL = "/images/site/event-plug.png";

const props = defineProps({
  type: {
    type: String,
    default: "",
  },
  date: {
    type: String,
    required: true,
  },
  firstTeamName: {
    type: String,
    default: "",
  },
  secondTeamName: {
    type: String,
    default: "",
  },
  firstTeamImage: {
    type: String,
    default: "",
  },
  secondTeamImage: {
    type: String,
    default: "",
  },
  to: {
    type: String,
    default: "",
  },
  isHomeLogoWithOpponent: {
    type: Boolean,
    default: true,
  },
  name: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="event">
    <template v-if="isHomeLogoWithOpponent">
      <div class="event__type">{{ type }}</div>
      <div class="event__date">
        <div class="event__date-day">{{ dayjs(date).format("DD MMMM YYYY") }}</div>
        <div class="event__date-time">
          {{ dayjs(date).format("dd") }}
          {{ dayjs(date).format("HH:mm") }}
        </div>
      </div>
      <div class="event__teams">
        <div class="event__team event__team_first">
          <h6>{{ firstTeamName }}</h6>
          <img
            class="event__team-image"
            :src="firstTeamImage ? firstTeamImage : DEFAULT_ICON_URL"
            :alt="firstTeamName"
          />
        </div>
        <div class="event__dots">:</div>
        <div class="event__team event__team_second">
          <img
            class="event__team-image"
            :src="secondTeamImage ? secondTeamImage : DEFAULT_ICON_URL"
            :alt="secondTeamName"
          />
          <h6>{{ secondTeamName }}</h6>
        </div>
      </div>
      <div class="event__actions">
        <a :href="to" class="btn btn_primary">Купить билет</a>
      </div>
    </template>
    <template v-else>
      <div class="event__type">{{ type }}</div>
        <div class="event__date">
          <div class="event__date-day">{{ dayjs(date).format("DD MMMM YYYY") }}</div>
          <div class="event__date-time">
            {{ dayjs(date).format("dd") }}
            {{ dayjs(date).format("HH:mm") }}
          </div>
        </div>
        <div class="event__teams event__teams_single">
          <div class="event__team event__team_first">
            <h6>{{ name || firstTeamName }}</h6>
            <img
              class="event__team-image"
              :src="firstTeamImage ? firstTeamImage : DEFAULT_ICON_URL"
              :alt="firstTeamName"
            />
          </div>
        </div>
        <div class="event__actions">
          <a :href="to" class="btn btn_primary">Купить билет</a>
        </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.event {
  width: 100%;
  padding: 12px;
  border-radius: 16px;
  background-color: $black;
  display: grid;
  grid-template-areas:
    "type teams ."
    "date teams action";
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto auto;
  gap: 6px;
  background-image: url("../../../../images/site/pattern.png");
  background-position: right;
  background-repeat: no-repeat;

  @media screen and (max-width: $screen-md-min) {
    grid-template-areas:
      "type date"
      "teams teams"
      "action action";
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;
    gap: 20px;
  }

  &__type {
    padding: 6px 18px;
    background-color: $grey;
    display: inline-block;
    border-radius: 16px;
    font-size: 10px;
    grid-area: type;
    align-self: start;
    justify-self: start;
  }

  &__team-image {
    width: 78px;
    height: 78px;
    object-fit: contain;
    border-radius: 10px;
  }

  &__actions {
    grid-area: action;
    align-self: end;
    justify-self: end;

    @media screen and (max-width: $screen-small) {
      justify-self: stretch;
    }

    a {
      display: inline-block;
      text-align: center;

      @media screen and (max-width: $screen-small) {
        width: 100%;
      }
    }
  }

  &__date {
    grid-area: date;
    color: $white;
    font-size: 18px;

    @media screen and (max-width: $screen-md-min) {
      font-size: 12px;
    }
  }

  &__date-day,
  &__date-time {
    @media screen and (max-width: $screen-md-min) {
      text-align: end;
    }
  }

  &__teams {
    grid-area: teams;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    justify-content: center;
    gap: 16px;

    &_single {
      grid-template-columns: auto;
    }

    @media screen and (max-width: $screen-md-min) {
      grid-template-columns: auto auto auto;

      &_single {
        grid-template-columns: auto;
      }
    }
  }

  &__team {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: $white;
    gap: 10px;

    @media screen and (max-width: $screen-md-min) {
      flex-direction: column;
    }

    h6 {
      font-size: 18px;

      @media screen and (max-width: $screen-md-min) {
        text-align: center;
        font-weight: 700;
        font-size: 15px;
      }
    }

    &_first {
      justify-content: flex-end;

      @media screen and (max-width: $screen-md-min) {
        flex-direction: column-reverse;
      }
    }
  }

  &__dots {
    font-size: 25px;
    font-weight: 700;
    color: $white;
  }
}
</style>
